export const typeCss={
    secondary:"secondary",
    tertiary:"tertiary"

}